import { Spin } from "antd";
import {
  ArrowUpIcon,
  ArrowDownIcon,
  TodayIcon,
  ThisWeekIcon,
  ThisMonthIcon,
  ThisYearIcon,
} from "pages/internal-dashboard/icons";
import { ConditionalRenderer } from "components/conditonal-renderer";
import styles from "./styles.module.scss";

export function CustomBoxV2({
  color,
  userCount,
  boxData,
  percentages,
  loading,
}: any) {
  const BoxIcon = boxData?.icon;
  const { day, month, week, year } = percentages || {};
  return (
    <div
      className={styles.totalUsers}
      style={{ "--color": color } as React.CSSProperties}
    >
      <ConditionalRenderer condition={loading}>
        <div className={styles.loading}>
          <Spin />
        </div>
      </ConditionalRenderer>

      <div className={styles.gradientBox}>
        <div className={styles.userText}>
          <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <span className={styles.userIcon}>
              {BoxIcon ? <BoxIcon /> : ""}
            </span>
            <h2 className={styles.title}>{boxData?.label}</h2>
          </div>
          <div className={styles.userCount}>{userCount}</div>
        </div>
        <div className={styles.valuesBoxes}>
          <div className={styles.firstRow}>
            <ValueBox
              boxTitle="Today"
              boxValue={boxData?.todayCount}
              percentage={day}
              icon={TodayIcon}
              color="#006AB3"
            />
            <ValueBox
              boxTitle="This Week"
              boxValue={boxData?.weekCount}
              percentage={week}
              icon={ThisWeekIcon}
              color="#F4BD00"
            />
          </div>
          <div className={styles.secondRow}>
            <ValueBox
              boxTitle="This Month"
              boxValue={boxData?.monthCount}
              percentage={month}
              icon={ThisMonthIcon}
              color="#78BA2C"
            />
            <ValueBox
              boxTitle="This Year"
              boxValue={boxData?.yearCount}
              percentage={year}
              icon={ThisYearIcon}
              color="#1C1C1D"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

function ValueBox({ boxTitle, boxValue, percentage, icon, color }: any) {
  const percentageValue: number = Number(Number(percentage).toFixed(2));
  const DateIcon = icon;
  const isPositive: boolean = percentageValue >= 0;
  const iconToDisplay: JSX.Element = isPositive ? (
    <ArrowUpIcon />
  ) : (
    <ArrowDownIcon />
  );
  const percentageToDisplay: string | number = isPositive
    ? "+" + percentageValue
    : percentageValue;

  return (
    <div className={styles.valueBox}>
      <div className={styles.boxTitleIcon}>
        <div className={styles.boxIcon} style={{ backgroundColor: color }}>
          <DateIcon />
        </div>
        <div className={styles.text}>{boxTitle}</div>
      </div>
      <div className={styles.value}>{boxValue}</div>
      <div
        className={styles.percentage}
        style={{ visibility: isNaN(percentageValue) ? "hidden" : "visible" }}
      >
        {iconToDisplay}
        <span className={isPositive ? styles.increased : styles.decreased}>
          {percentageToDisplay}%
        </span>
      </div>
    </div>
  );
}
